define(function (require) {
    var UAParser = require('ua-parser');
    
    var Logger = function (namespace) {
        this._namespace = namespace;
    };

    Logger.prototype = {
        level: _config.ENVIRONMENT || 'production',
        get: function (namespace) {
            return new Logger(namespace);
        },
        debug: function (message) {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('debug');

            this.log.apply(this, args);
        },
        info: function (message) {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('info');

            this.log.apply(this, args);
        },
        warn: function (message) {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('warn');

            this.log.apply(this, args);
        },
        error: function (message) {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('error');

            this.log.apply(this, args);
        },
        log: function (type, message) {
            var app = require('system.app');
            
            if (message instanceof Function) {
                message = message();
            }

            if (message instanceof Object) {
                message = JSON.stringify(message);
            }

            var arg = arguments,
                    i = 2,
                    text = '[' + this._namespace + '] ' + message.replace(/%((%)|s)/g, function (m) {
                        var result = m[2] || arg[i++];
                        
                        if(result instanceof Object){
                            result = JSON.stringify(result);
                        }
                        
                        return result;
                    });

            if (typeof console !== 'undefined' && typeof console[type] !== 'undefined') {
                console[type](text);
            }

            if (type === 'error' && document.readyState === 'complete' && (this.level !== 'development')) {
                var posts = {
                    "userID": app.user.config().get('ID'),
                    "clientInfo": this.getClientInfo(),
                    "message": text
                };
                posts[app.security.csrf.getName()] = app.security.csrf.getToken();

                $.post('/system/processClientLog', posts);
            }
        },
        getClientInfo: function () {
            return new UAParser().getResult();
        }
    };

    var logger = new Logger('system');

    window.onerror = function (message, url, line) {
        new Logger('System').error('Application error: %s in file %s line number %s', message, url, line);
        return true;
    };

    return logger;
});